module.exports = __webpack_public_path__ + "img/save.a2844c8d.png";